// Minimal Markdown renderer for internal content.
// Supports: #/##/### headings, **bold**, _italic_, inline code `code`,
// paragraphs, and bullet lists (- or *). Not a full spec implementation.

export function mdToHtml(md) {
  if (!md) return '';
  const esc = s =>
    s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

  const lines = md.split(/\r?\n/);
  const out = [];
  let inList = false;
  const flushP = () => {
    if (inList) {
      out.push('</ul>');
      inList = false;
    }
  };
  for (let raw of lines) {
    const line = raw.trimEnd();
    if (!line.trim()) {
      flushP();
      out.push('');
      continue;
    }
    if (/^###\s+/.test(line)) {
      flushP();
      out.push(`<h3>${esc(line.replace(/^###\s+/, ''))}</h3>`);
      continue;
    }
    if (/^##\s+/.test(line)) {
      flushP();
      out.push(`<h2>${esc(line.replace(/^##\s+/, ''))}</h2>`);
      continue;
    }
    if (/^#\s+/.test(line)) {
      flushP();
      out.push(`<h1>${esc(line.replace(/^#\s+/, ''))}</h1>`);
      continue;
    }
    if (/^[-*]\s+/.test(line)) {
      if (!inList) {
        out.push('<ul>');
        inList = true;
      }
      out.push(`<li>${inline(line.replace(/^[-*]\s+/, ''))}</li>`);
      continue;
    }
    flushP();
    out.push(`<p>${inline(line)}</p>`);
  }
  flushP();
  return out.join('\n');

  function inline(s) {
    // Escape then replace formatting tokens
    let t = esc(s);
    t = t.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    t = t.replace(/_(.+?)_/g, '<em>$1</em>');
    t = t.replace(/`(.+?)`/g, '<code>$1</code>');
    return t;
  }
}
